import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import useModal from '../hooks/useModal';
import styles from '../styles/Testimonial.module.css';

const testimonials = [
  {
    quote: 'A cool bar and nice atmosphere.',
    author: 'Mila Petrova',
  },
  {
    quote: 'I never had so much fun.',
    author: 'Jonas Keller',
  },
  {
    quote: 'Really cool place.',
    author: 'Elena Marinova',
  },
  {
    quote: 'Come and experience it for yourself.',
    author: 'Leon Fischer',
  },
];

const Testimonial = ({ ctaLabel = 'Read all guest thoughts', ctaTo = '/Testimonials' }) => {
  const { value: selected, open, close } = useModal();

  useEffect(() => {
    if (!selected) return undefined;

    const closeOnEscape = event => {
      if (event.key === 'Escape') close();
    };

    document.addEventListener('keydown', closeOnEscape);
    return () => document.removeEventListener('keydown', closeOnEscape);
  }, [selected, close]);

  return (
    <section className={styles.section} aria-labelledby="testimonial-title">
      <div className={styles.inner}>
        <p className={styles.eyebrow}>Guest thoughts</p>
        <h2 id="testimonial-title">What the guests say</h2>
        <div className={styles.grid}>
          {testimonials.map(testimonial => (
            <button
              className={styles.card}
              key={testimonial.author}
              type="button"
              onClick={() => open(testimonial)}
              aria-label={`Read testimonial from ${testimonial.author}`}
            >
              <span className={styles.mark} aria-hidden="true">“</span>
              <span className={styles.cardQuote}>{testimonial.quote}</span>
              <span className={styles.author}>{testimonial.author}</span>
              <span className={styles.overlay} aria-hidden="true">
                Read guest thought
              </span>
            </button>
          ))}
        </div>
        <Link className={styles.cta} to={ctaTo}>
          {ctaLabel}
        </Link>
      </div>

      {selected && (
        <div
          className={styles.backdrop}
          role="presentation"
          onClick={event => {
            if (event.target === event.currentTarget) close();
          }}
        >
          <div
            className={styles.modal}
            role="dialog"
            aria-modal="true"
            aria-labelledby="testimonial-modal-title"
          >
            <button
              className={styles.close}
              type="button"
              onClick={close}
              aria-label="Close testimonial"
            >
              ×
            </button>
            <p className={styles.modalLabel}>Guest thought</p>
            <h3 id="testimonial-modal-title">{selected.author}</h3>
            <p className={styles.modalQuote}>„{selected.quote}”</p>
          </div>
        </div>
      )}
    </section>
  );
};

export default Testimonial;
